import { Popup } from "react-leaflet";

import {
  Typography,
  Box,
  Card,
  CardContent,
  Chip,
  Divider,
} from "@mui/material";
import {
  LocalOffer as IdentifierIcon,
  Info as StatusIcon,
  Category as SeverityIcon,
} from "@mui/icons-material";

const LeakPopup = ({ feature, onClick }) => {
  const getStatusLabel = (status) => {
    // Esto se tiene que ir para otro sitio
    switch (status) {
      case 0:
        return "Detected";
      case 1:
        return "Confirmed";
      case 2:
        return "Controlled";
      case 3:
        return "Escalating";
      case 4:
        return "Remediated";
      default:
        return "Unknown";
    }
  };

  const getSeverityLabel = (severity) => {
    // Esto se tiene que ir para otro sitio
    switch (severity) {
      case 1:
        return "Minor";
      case 2:
        return "Moderate";
      case 3:
        return "Major";
      case 4:
        return "Remediated";
      default:
        return "Unknown";
    }
  };
  return (
    <Popup offset={[0,-25]}> {/* On top of the icon */}
      <Card
        elevation={3}
        sx={{
          borderRadius: 2,
          cursor: "pointer",
          minWidth: 235,
          bgcolor: 'none',
          boxShadow: 'none',
          padding: 0

        }}
        onClick={() => onClick(feature)}
        className="leak-popup-card"
      >
        <CardContent sx={{ padding: "5px" }}>
          <Box display="flex" alignItems="center" mb={2}>
            <IdentifierIcon color="primary" sx={{ mr: 1 }} fontSize="small" />
            <Typography variant="h7" component="div" fontWeight="bold">
              {feature.properties.identifier}
            </Typography>
          </Box>
          <Divider />
          <Box mt={2}>
            <Box display="flex" alignItems="center" mb={2}>
              <StatusIcon color="info" sx={{ mr: 1 }} />
              <Typography variant="body2" color="text.secondary">
                Status:
              </Typography>
              <Chip
                label={getStatusLabel(feature.properties.leak_status)}
                size="small"
                color="primary"
                variant="outlined"
                sx={{ ml: 1 }}
              />
            </Box>
            <Box display="flex" alignItems="center">
              <SeverityIcon color="warning" sx={{ mr: 1 }} />
              <Typography variant="body2" color="text.secondary">
                Severity:
              </Typography>
              <Chip
                label={getSeverityLabel(
                  feature.properties.leak_severity
                )}
                size="small"
                color={getSeverityLabel(
                  feature.properties.leak_severity
                ).toLowerCase()}
                variant="success"
                sx={{ ml: 1 }}
              />
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Popup>
  );
};

export default LeakPopup;
